import { ClientDashboardJobOrderDto } from '@hoqus/connectis-client-dashboard-types';
import { JobOrderType } from './JobOrderType.ts';

export const mapDtoToJobOrderType = (dto: ClientDashboardJobOrderDto): JobOrderType => ({
  id: dto.id,
  displayDate: dto.displayDate,
  status: dto.status,
  name: dto.name,
  vacancies: dto.vacancies,
  availability: dto.availability,
  workType: dto.workType,
  seniority: dto.seniority,
  experienceYears: Math.round(dto.experienceYears || 0),
  englishLevel: dto.englishLevel,
});
